import makeStyles from '@mui/styles/makeStyles'
import { MyAccountTheme } from '@dxp-module/themes'
import { MyAccountObjectFieldTemplateClasses } from '@dxp-module/themes/src'

const objectFieldTemplateStyles = makeStyles<
  MyAccountTheme,
  object,
  MyAccountObjectFieldTemplateClasses
>(
  ({ breakpoints, typography }) => ({
    header: {
      margin: '16px auto 28px',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column-reverse',
      [breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    root: {
      flexBasis: 'initial',
    },
    child: {
      marginBottom: 15,
    },
    singleField: {
      marginBottom: '20px',
    },
    singleFieldMiniWidget: {
      padding: 0,
      marginBottom: '20px',
    },
    content: {
      fontSize: typography.fontMD,
    },
  }),
  { name: 'Common_ObjectFieldTemplate' }
)

export default objectFieldTemplateStyles
